// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ff854d58","498":"427e220e","550":"94bb7f2c","703":"0e7b2ef9"}[chunkId] + ".chunk.js";
};